// BHP-1062: the `installation` label that WordPress and Linked Helper
// provisioning writes on the Hetzner server. Extracted so both pages show it
// the same way instead of each carrying its own copy of the list.
const KNOWN: string[] = [
  'initialize',
  'manual',
  'running',
  'finished',
  'unknown'
];

const STYLES: Record<string, string> = {
  finished: 'bg-teal-50 text-teal-700',
  running: 'bg-amber-50 text-amber-700',
  initialize: 'bg-amber-50 text-amber-700'
};

export default function InstallationState({
  labels
}: {
  labels: Record<string, string>;
}): JSX.Element {
  const raw = labels.installation ?? 'unknown';
  // An unrecognised value is shown as "unknown" rather than passed through:
  // the label is free text on the Hetzner side, so anything could be in it.
  const state = KNOWN.includes(raw) ? raw : 'unknown';

  return (
    <div className="rounded-xl border border-solid border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="mb-2 text-sm font-semibold text-slate-800">
        Installation
      </h3>
      <span
        className={`inline-block rounded px-2 py-0.5 text-xs font-medium ${
          STYLES[state] ?? 'bg-slate-100 text-slate-600'
        }`}
      >
        {state}
      </span>
    </div>
  );
}
